import { type Ref, unref, computed } from "vue";
import { useQuery } from "@tanstack/vue-query";
import Billing from "@/services/billing/billing";

export interface UsageStatsParams {
  startDate?: string;
  endDate?: string;
  userId?: string;
}

export function useUsageStats(params: Ref<UsageStatsParams> | UsageStatsParams = {}) {
  const queryKey = computed(() => ["billing", "usageStats", unref(params)]);

  return useQuery({
    queryKey,
    queryFn: async () => {
      const p = unref(params);
      const result = await Billing.getUsageStats(p);
      const payload = result?.data as { status?: boolean; data?: unknown };
      if (payload?.status && payload?.data != null) return payload.data;
      return null;
    },
    staleTime: 0,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
}
